import {ColorRestDto, ColorSolidRestDto} from "@/api/pharma-cms-content-page/models";
import {ColorRestDtoModel} from "@/models/api/ColorRestDtoModel";
import {BackgroundColorEnum} from "@/api/enums/background-color-enum";

export class ColorSolidRestDtoModel implements ColorSolidRestDto {
    rgba?: ColorRestDto | null;
    color_code?: BackgroundColorEnum | null;

    static createWithDefaults(): ColorSolidRestDtoModel {
        return new this();
    }

    static cloneFrom(source: ColorSolidRestDto): ColorSolidRestDtoModel {
        const clone: ColorSolidRestDtoModel = new this();

        clone.color_code = source.color_code;
        if (source.rgba) {
            clone.rgba = ColorRestDtoModel.cloneFrom(source.rgba);
        }

        return clone;
    }

    /**
     * Neither a token nor a custom colour: the colour carries nothing at all.
     *
     * The API sends a colour back as an object with null members rather than as a null, so a
     * colour that was never filled in cannot be recognized by its presence alone.
     */
    static isEmpty(source?: ColorSolidRestDto | null): boolean {
        return !source || (!source.color_code && !source.rgba);
    }
}
